import api from '../../services/api';
import { API_BASE_URL } from '../../constants/api';

const BASE = '/pulse';

const PulseService = {
  listModels: () => api.get(`${BASE}/models`),

  listConversations: () => api.get(`${BASE}/conversations`),
  createConversation: (payload = {}) => api.post(`${BASE}/conversations`, payload),
  getConversation: (id) => api.get(`${BASE}/conversations/${id}`),
  renameConversation: (id, title) => api.patch(`${BASE}/conversations/${id}`, { title }),
  setModel: (id, model) => api.patch(`${BASE}/conversations/${id}`, { model }),
  deleteConversation: (id) => api.delete(`${BASE}/conversations/${id}`),

  postMessage: (id, content, model) =>
    api.post(`${BASE}/conversations/${id}/messages`, { content, model }),

  /**
   * Streaming send. Calls onEvent for each SSE payload:
   *   { type: 'tool', name } | { type: 'token', content } |
   *   { type: 'done', conversation, userMessage, assistantMessage } |
   *   { type: 'error', message }
   */
  postMessageStream: async (id, content, onEvent) => {
    const response = await fetch(`${API_BASE_URL}${BASE}/conversations/${id}/messages/stream`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content })
    });

    if (!response.ok || !response.body) {
      let message = 'Send failed';
      try {
        const err = await response.json();
        message = err.message || message;
      } catch { /* non-JSON error body */ }
      throw new Error(message);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    let streamDone = false;
    while (!streamDone) {
      const { done, value } = await reader.read();
      if (done) { streamDone = true; break; }
      buffer += decoder.decode(value, { stream: true });

      // SSE frames are separated by a blank line.
      const frames = buffer.split('\n\n');
      buffer = frames.pop(); // keep the trailing partial frame
      for (const frame of frames) {
        const line = frame.split('\n').find((l) => l.startsWith('data: '));
        if (!line) continue;
        try {
          onEvent(JSON.parse(line.slice(6)));
        } catch { /* skip malformed frame */ }
      }
    }
  }
};

export default PulseService;
